import styled from 'styled-components';

export const PopHeaderMainWrap = styled.div(
    props => `
        display: flex;
        width:100%;
    `
);

export const PopHeaderWrap = styled.div(
    props => `
        display: flex;
        width:100%;
        align-items: center;
        justify-content: ${props.alignRight ? 'space-between' : 'flex-end'};
        @media only screen and (max-width:768px){
            margin-top:2rem;
        }
    `
);

export const PopHeaderBackWrap = styled.div(
    props => `
        display: flex;
        align-items: center;
        width:20%;
        opacity: ${props.disabled ? '0.5' : '1'};
        pointer-events: ${props.disabled ? 'none' : ''};
        justify-content: ${props.alignRight ? 'flex-start' : 'flex-end'};
    `
);

export const PopHeaderBackText = styled.a(
    props => `
        color: #000;
        font-size: 1.2rem;
        font-weight: bold;
        text-decoration: none;
        text-transform: uppercase;
        cursor: pointer;
    `
);

export const PopHeaderStepWrap = styled.div(
    props => `
        width:80%;
        display: ${props.disabled ? 'none' : 'flex'};
        align-items: center;
        justify-content: flex-end;
    `
);

export const PopHeaderSessionWrap = styled.div(
    props => `
        display: flex;
        background-color: #ffefdc;
        padding:0.4rem 0.6rem;
        border-radius: 0.4rem;
        margin-right: 1rem;
    `
);

export const PopHeaderSessionText = styled.p(
    props => `
        font-size: 1rem;
        color: #dc8319;
        text-transform: uppercase;
        span{
            font-weight: bold;
            text-transform:lowercase;
        }
    `
);

export const PopHeaderStepInnerWrap = styled.div(
    props => `
        display: flex;
        position: relative;
        margin-top:-0.4rem;
    `
);

export const PopHeaderStepText = styled.p(
    props => `
        font-size: 1.2rem;
        color: rgba(0,0,0,0.3);
        font-weight: bold;
        span{
            color: #000;
            font-weight: 900;
        }
    `
);

export const SignUpStepIndicatorWrap = styled.div(
    props => `
        position: absolute;
        bottom: -0.4rem;;
        left:0;
        height: .4rem;
        background-color: rgba(0, 145, 255, 0.3);
        width: 6.6rem;
        border-radius:1rem;
    `
)

export const SignUpStepIndicator = styled.span(
    props => `
          position: absolute;
          bottom: 0rem;;
          left:0;
          height: .4rem;
          background-color: #0091ff;
          width: 2.2rem;
          border-radius:1rem;
      `,
  );
  
  export const SignUpStepIndicatorTwo = styled.span(
    props => `
          position: absolute;
          bottom: 0rem;;
          left:0;
          height: .4rem;
          background-color: #0091ff;
          width: 4.4rem;
          border-radius:1rem;
      `,
  );
  
  export const SignUpStepIndicatorThree = styled.span(
    props => `
          position: absolute;
          bottom: 0rem;;
          left:0;
          height: .4rem;
          background-color: #0091ff;
          width: 6.6rem;
          border-radius:1rem;
      `,
  );
